import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const MAX_BADGES = 3;

function getPageNumbers(current, total) {
  if (total <= MAX_BADGES) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  let start = current - 1;
  let end = current + 1;
  if (start < 1) {
    start = 1;
    end = MAX_BADGES;
  } else if (end > total) {
    end = total;
    start = total - MAX_BADGES + 1;
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}

function Pagination({ page, totalPages, totalItems, pageSize, onPageChange }) {
  if (totalItems === 0) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalItems);
  const pageNumbers = getPageNumbers(page, totalPages);

  return (
    <div className="flex items-center justify-between gap-2 px-3 sm:px-5 py-3 border-b border-gray-100 overflow-x-auto">
      <p className="text-sm text-gray-500 shrink-0 whitespace-nowrap">
        Showing <span className="font-medium text-gray-700">{from}–{to}</span> of{' '}
        <span className="font-medium text-gray-700">{totalItems}</span>
      </p>

      <div className="flex items-center gap-1 shrink-0">
        <button
          type="button"
          onClick={() => onPageChange(1)}
          disabled={page === 1}
          aria-label="Go to first page"
          className="p-1.5 rounded-md text-gray-600 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-transparent"
        >
          <ChevronLeftIcon className="h-4 w-4" />
        </button>

        {pageNumbers.map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => onPageChange(n)}
            aria-current={n === page ? 'page' : undefined}
            className={`h-8 min-w-[2rem] px-2 rounded-md text-sm font-medium transition ${
              n === page ? 'bg-gold text-navy font-bold' : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            {n}
          </button>
        ))}

        <button
          type="button"
          onClick={() => onPageChange(totalPages)}
          disabled={page === totalPages}
          aria-label="Go to last page"
          className="p-1.5 rounded-md text-gray-600 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-transparent"
        >
          <ChevronRightIcon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}

export default Pagination;
